import { Link } from 'react-router-dom';

// Services
import { type BlocListeType } from '@/services/blocksSchema';

// Components
import PreTitle from '@/components/atoms/PreTitle/PreTitle';
import Heading from '@/components/atoms/Heading/Heading';

import { useNormalizedLink } from '@/hooks/useNormalizedLink';

// Style
import styles from './BlocListe.module.css';

interface BlocListeProps {
  preTitle: BlocListeType['preTitle'];
  title: BlocListeType['title'];
  items: BlocListeType['items'];
}

function BlocListe({
  preTitle,
  title,
  items,
}: BlocListeProps) {
  const normalizeLink = useNormalizedLink();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <PreTitle
          preTitle={preTitle}
          color='dark'
        />
        <Heading
          title={title}
          color='dark'
          size='h2'
          Tag='h2'
          align='center'
        />
        <div className={styles.items}>
          {
            items.map((item) => (
              <Link
                key={item.title}
                className={styles.item}
                to={normalizeLink(item.url)}
              >
                {item.title}
              </Link>
            ))
          }
        </div>
      </div>
    </div>
  );
}

export default BlocListe;
